
import Tab from "../components/Tab.vue";
import ListMajor from "../components/InteractiveComponents/ListMajor.vue";
import MajorSection from "../components/MajorSection.vue";
import MajorResult from "../components/MajorResult.vue";
import YourSchool from "../components/InteractiveComponents/YourSchool.vue";
import ListSchool from "../components/ListSchool.vue";
import MajorDes from "../components/MajorDes.vue";
import TopSchool from "../components/InteractiveComponents/TopSchool.vue";
import { mapState } from "vuex";
import EventNews from "../components/InteractiveComponents/EventNews.vue";
export default {
  layout: "root",
  components: {
    Tab,
    ListMajor,
    MajorSection,
    MajorResult,
    YourSchool,
    ListSchool,
    MajorDes,
    TopSchool,
    EventNews,
  },
  computed: {
    ...mapState("SchoolDetail", [
      "school_detail",
      "school_address",
      "school_infra",
      "school_staffs",
      "school_links",
    ]),
  },
  asyncData({ params, query, store }) {
    const { type } = params;

    if (type === "majors" || type === "nganh-hoc") {
      // gn = groupMajorName , mn = majorName
      const { gn, mn, comp } = query;
      return {
        groupMajorName: gn || "",
        majorName: mn || "",
        currentComponent: comp || "ListMajor",
      };
    }
  },
  data() {
    return {
      searchValue: "",
      currentComponent: "ListMajor",
      majorName: "",
      groupMajorName: "",
      mediaUrl: this.$config.BASE_URL_RESOURCE,
    };
  },

  mounted() {
    window.setMajorPage = this.setComponent;
  },
  methods: {
    majorDesBack(){
      this.currentComponent ='ListMajor'
    },
    setSearchValue(value) {
      this.searchValue = value;
    },
    setComponent(name) {
      this.currentComponent = name;
    },
    setMajorName(name) {
      this.majorName = name;
    },
    setGroupMajorName(name) {
      this.groupMajorName = name;
    },
  },
};
